import { RelativeDateDisplayMetric } from '@pushly/models/lib/enums/relative-date-display-metric'

export const SESSION_METRICS_FILTERED = [RelativeDateDisplayMetric.SECONDS, RelativeDateDisplayMetric.MINUTES]
export const LIFETIME_METRICS = Object.values(RelativeDateDisplayMetric)

// Display Values slightly differ from assigned property value for 'X_TIME_IN_APP' [type: AppMessageConditionType] - calculated with config requirements
export const SESSION_TRIGGER_TYPES = ['SESSION_START', 'TIME_IN_APP', 'CUSTOM']

export const DEFAULT_TOGGLEABLE_FG_COLOR = '#111111'
export const DEFAULT_CTA_FG_COLOR = '#FFFFFF'

export const DEFAULT_TOGGLEABLE_BG_COLOR = '#FFFFFF'
export const DEFAULT_CTA_BG_COLOR = '#111111'
